module.exports = {"chestPain01":"2.1.0","gpChestPain01":"1.1.5","gallbladder01":"1.1.1","dxaScan01":"1.1.3","accmri01":"1.0.0","accbist01":"1.0.0"}


//////////////////
// WEBPACK FOOTER
// ./src/config/documentVersions.json
// module id = 180
// module chunks = 0